import { markRaw } from 'vue'
import SignIn from '../layout/auth/components/SignIn.vue'
import { createStore } from 'vuex'
import SharedService from '../services/shared'
import { showToast as toast } from '@/helpers/UseToasts'
import Events from '../layout/authenticated/home.vue'

export const dataShared = createStore({
  state: () => {
    return {
      // novos states
      menuActive: null,
      
      appLogo: null,
      dataUserLogged: null,

      // https
      blockButtonsForHttpStatus29: false,
      cIdByCookie: null,

      // profile
      profile: {
        // p_password: null
      },

      // login
      bannerLogin: null,
      activeComponentLogin: SignIn,
      cLogin: {
        signIn: {
          email: null,
          password: null
        },
        signUp: {
          name: null,
          email: null,
          password: null
        }
      },

      componentActive: Events,
      eventLiveId: null,
      eventLiveActived: null,
      groupLiveActived: null,
      loading: false,

      // theme
      blackTheme: false,

      // customer
      customer: [],
      customerId: [],
      isFighter: false,

      // noticias
      notices: [],
      noticeActiveById: null,

      // eventos
      events: [],
      nextEvents: [],
      eventPurchase: null,
      mainEvent: null,

      // certificados
      managerGroups: null,
      modalGroupsOpen: null,
      modalGroupSelected: [],
      skeletonLoader: false,

      // lives
      lives: [],

      // profile

      // modules
      moduleActive: null,
      lessonActive: null,

      lastClass: null,
      lessonRestartToken: 0,

    }
  },
  getters: {
    getMenuActive: (state) => state.menuActive,

    getAppLogo: (state) => state.appLogo = require('@/assets/logo/login-logo.png'),
    getActiveComponent: (state) => state.componentActive,
    getTheme: (state) => state.blackTheme,
    getNotices: (state) => state.notices,
    getEvents: (state) => state.events,
    getLives: (state) => state.lives,
    getNextEvents: (state) => state.nextEvents,
    seeNoticeActivated: (state) => state.noticeActiveById,
    eventPurchase: (state) => state.eventPurchase,
    getMainEvent: (state) => state.mainEvent,
    getCustomerData: (state) => state.customer,
    getCustomerId: (state) => state.customerId,
    getIsFighter: (state) => state.isFighter,
    getLoading: (state) => state.loading,
    getSkeletonLoading: (state) => state.skeletonLoader,
    bannerLogin: (state) => state.bannerLogin,
    getActiveComponentLogin: (state) => state.activeComponentLogin,
    buttonsBlockedForHttp29: (state) => state.blockButtonsForHttpStatus29,
    getCIdByCookie: (state) => state.cIdByCookie,
    getDataByUserLogged: (state) => state.dataUserLogged,
    
    // certificate
    getDataGroupManager: (state) => state.managerGroups, // grupos
    // getDataGroupManager: (state) => state.managerGroups, // dados para export
    getModalGroupsOpen: (state) => state.modalGroupsOpen,
    getDataGroupSelected: (state) => state.modalGroupSelected,
    getSkeletonLoader: (state) => state.skeletonLoader,
    
    getActivatedModule: (state) => state.moduleActive,
    getActivatedLesson: (state) => state.lessonActive,
    getLastLessonActive: (state) => state.lastClass,
    getEventLiveId: (state) => state.eventLiveId,
    getEventLiveActivated: (state) => state.eventLiveActived,
    getGroupContextId: (state) => state.groupLiveActived
  },
  mutations: {
    SET_GROUP_CONTEXT(state, payload) {
      state.groupLiveActived = payload ?? null
    },
    SET_MENU_ACTIVE (state, value) {
      state.menuActive = value
    },
    SET_COMPONENT_ACTIVE (state, value) {
      // excluir
    },
    SET_THEME (state, value) {
      state.blackTheme = value
    },
    SET_MAIN_EVENT (state, value) {
      state.mainEvent = value
    },
    SET_LIVE_ACTIVE (state, payload) {
      state.eventLiveId = payload.id
      state.eventLiveActived = payload
    },
    SET_COLLECTION_NOTICE (state, payload) {
      state.notices = []
      state.notices = {
        latest: payload.latest || [],
        recommended: payload.recommended || [],
        hot_now: payload.hot_now || [],
        older: payload.older || []
      }
    },
    SET_EVENT_COLLECTION (state, payload) {
      state.events = []
      state.events = payload
    },
    SET_LIVES_COLLECTION (state, payload) {
      state.lives = []
      state.lives = payload
    },
    SET_NEXT_EVENTS (state, payload) {
      state.nextEvents = []
      state.nextEvents = payload
    },
    SET_NOTICE_ACTIVATED (state, id) {
      let found = null

      for (const category of Object.values(state.notices)) {
        const notice = category.find(n => n.id === id)
        if (notice) {
          found = notice
          break
        }
      }

      if (found) {
        state.noticeActiveById = found
      }
    },
    SET_EVENT_TO_PURCHASE (state, id) {
      const event = state.events.find(n => n.id === id)

      if (event) {
        state.eventPurchase = event
      }
    },
    SET_CUSTOMER_DATA (state, payload) {
      state.customer = payload
    },
    SET_CUSTOMER_ID (state, payload) {
      state.customerId = payload
    },
    SET_IS_FIGHTER (state, payload) {
      state.isFighter = payload
    },
    LOADING (state, payload) {
      state.loading = payload
    },
    LOADING_SKELETON (state, payload) {
      state.skeletonLoader = payload
    },
    SET_BANNER_LOGIN (state, payload) {
      state.bannerLogin = payload
    },
    SET_COMPONENT_ACTIVE_LOGIN (state, value) {
      state.activeComponentLogin = value
    },
    SET_TIMER_FOR_HTTP_29 (state) {
      state.blockButtonsForHttpStatus29 = true

      setInterval(() => {
        state.blockButtonsForHttpStatus29 = false
      }, 60000) // 1 minuto
    },
    GET_CUSTOMER_ID_BY_COOKIE (state, id) {
      state.cIdByCookie = id
    },
    SET_USER (state, payload) {
      state.dataUserLogged = payload
    },
    SET_MODULE_ACTIVE (state, payload) {
      state.moduleActive = payload
    },
    SET_LESSON_ACTIVE (state, payload) {
      state.lessonActive = payload
    },
    SET_LAST_CLASS_ACTIVE (state, payload) {
      state.lastClass = payload
    },
    RESTART_LESSON(state) {
      state.lessonRestartToken++
    },
    SET_DATA_GROUP_MANAGER(state, val) {
      state.managerGroups = val
    },
    MODAL_GROUPS_OPEN(state, payload) {
      state.modalGroupsOpen = payload
    },
    SET_DATA_MODAL_GROUP(state, payload) {
      state.modalGroupSelected = payload
    },
  },
  actions: {
    // grupos
    setTrainingContext({ commit }, payload) {
      commit('SET_GROUP_CONTEXT', payload)
    },

    // certificados
    async setDataGroupManager ({ commit }) {
      dataShared.dispatch('activeLoading')
      await SharedService.groups()
        .then(res => {
          dataShared.dispatch('desactiveLoading')
          commit('SET_DATA_GROUP_MANAGER', res.data)
        }).catch(err => {
          if (err.response.data.error === 401) {
            toast(
              'Aviso',
              'Sua sessão expirou, faça login',
              'error'
            )
          dataShared.dispatch('desactiveLoading')
          router.push('/auth')
        }
      })
    },
    async exportDataByGroupId ({ commit }, payload) {
      // dataShared.dispatch('activeSkeletonLoading')
      this.dispatch('activeLoading')
      console.log(payload);
      await SharedService.exportDataGroupBy(payload.id, payload.name).finally(() => {
        this.dispatch('desactiveLoading')
      })
      // .then(res => {
      //   dataShared.dispatch('desactiveSkeletonLoading')
      //   commit('SET_DATA_GROUP_MANAGER', res.data)
      // }).catch(err => {
      //   if (err.response.data.error === 401) {
      //     toast(
      //       'Aviso',
      //       'Sua sessão expirou, faça login',
      //       'error'
      //     )
      //   dataShared.dispatch('desactiveSkeletonLoading')
      //   router.push('/auth')
      // }
      // })
    },
    setModalOpen({ commit }, val) {
      commit('MODAL_GROUPS_OPEN', val);
    },
    setDataModalOpen({ commit }, val) {
      commit('SET_DATA_MODAL_GROUP', val);
    },

    // novas actions
    setActivatedMenu ({ commit }, val) {
      commit('SET_MENU_ACTIVE', val)
    },
    setModuleActivated ({ commit }, val) {
      commit('SET_MODULE_ACTIVE', val)
    },
    setLessonActivated ({ commit }, val) {
      commit('SET_LESSON_ACTIVE', val)
    },
    setLastClassActive ({ commit }, val) {
      commit('SET_LAST_CLASS_ACTIVE', val)
    },
    restartLesson({ commit }) {
      commit('RESTART_LESSON')
    },

    setTheme ({ commit }, value) {
      commit('SET_THEME', value)
    },
    setLiveActive ({ commit }, value) {
      commit('SET_LIVE_ACTIVE', value)
    },
    setAllNotices ({ commit }, payload) {
      commit('SET_COLLECTION_NOTICE', payload)
    },
    setAllEvents ({ commit }, payload) {
      commit('SET_EVENT_COLLECTION', payload)
    },
    setAllLives ({ commit }, payload) {
      commit('SET_LIVES_COLLECTION', payload)
    },
    setNextEvents ({ commit }, payload) {
      commit('SET_NEXT_EVENTS', payload)
    },
    setNoticeActive ({ commit }, payload) {
      commit('SET_NOTICE_ACTIVATED', payload)
    },
    setEventToPurchase ({ commit }, payload) {
      commit('SET_EVENT_TO_PURCHASE', payload)
    },
    setMainEvent ({ commit }, payload) {
      commit('SET_MAIN_EVENT', payload)
    },
    setCustomer ({ commit }, payload) {
      commit('SET_CUSTOMER_DATA', payload)
    },
    setCustomerId ({ commit }, payload) {
      commit('SET_CUSTOMER_ID', payload)
    },
    setIsFighter ({ commit }, payload) {
      commit('SET_IS_FIGHTER', payload)
    },
    activeLoading ({ commit }) {
      commit('LOADING', true)
    },
    desactiveLoading ({ commit }) {
      commit('LOADING', false)
    },
    activeSkeletonLoading ({ commit }) {
      commit('LOADING_SKELETON', true)
    },
    desactiveSkeletonLoading ({ commit }) {
      commit('LOADING_SKELETON', false)
    },
    setBannerLogin ({ commit }, value) {
      commit('SET_BANNER_LOGIN', value)
    },
    setComponentActive ({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE', value)
    },
    setComponentActiveLogin ({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE_LOGIN', value)
    },
    getCookieByName ({ commit }, cookieName) {
      const id = Cookies.get(cookieName) || null
      commit('SET_CUSTOMER_ID_BY_COOKIE', id)
      return id
    },
    async fetchLoggedUser ({ commit }) {
      /**
       * TODO
       * 
       * Validar informações antes
       * o que define que meu usuário esta logado?
       * perco os dados do meu aluno se não fizer isso toda hora
       */
      await SharedService.me()
        .then(res => {
          if (res.data && res.data.id) {
            commit('SET_USER', res.data)
          }
        }).catch(err => {
          if (err?.response?.data?.error && err.response.data.status === 429) {
            toast(
              'Aviso',
              'Multiplas tentataivas',
              'error'
            )
            dataShared.dispatch('set29')
          }

          if (err?.response?.data?.error && err.response?.data?.status === 401) {
            toast(
              'Aviso',
              err.response.data.message,
              'error'
            )
          }
        })
    },
    // http
    set29 ({ commit }) {
      commit('SET_TIMER_FOR_HTTP_29')
    }
  }
})
